const state = {
  enabled: false,
  wrapper: { el: null, selector: null },
  highlighted: { el: [], selector: [] },
  permanentSidebar: true,
};

const getters = {
  activeOnboardingEl: (state) => state.highlighted.el,
  activeOnboardingWrapperSelector: (state) => state.wrapper.selector,
  activeOnboardingHighlightedSelector: (state) => state.highlighted.selector,
  isOnboardingEnabled: (state) => state.enabled,
  onboardingPermanentSidebar: (state) => state.permanentSidebar && state.enabled,
};

const actions = {};

const mutations = {
  updateWrapperEl(state, selector) {
    state.wrapper.el = document.querySelector(selector);
    state.wrapper.selector = selector;
  },
  updateOnboardingHighlightSelectors(state, selectors) {
    state.highlighted.el = [];
    if (!selectors) {
      return;
    }

    selectors.forEach((selector) => {
      state.highlighted.el.push(document.querySelector(selector));
    });
    // state.highlighted.el
    // state.highlighted.el = document.querySelector(selector);
    state.highlighted.selector = selectors;
  },
  setOnboardingEnabled(state, isEnabled) {
    state.enabled = isEnabled;
  },
  setOnboardingPermanentSidebar(state, isEnabled) {
    state.permanentSidebar = isEnabled;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
